export default __webpack_public_path__ + "static/media/Salah.bfa4c05c.png";